import React from "react";
import ShortcutMenuWrapper from "../ShortcutMenuWrapper";
import UserManagementIcon from "assets/menus/master-maintenance/user-management-1.svg";
import { useSelector } from "react-redux";
import { RootState } from "@app/store/store";
import { canAccess } from "@app/utils/permissionUtils";

export const AgentManagementMenu: React.FC = () => {
    const state = useSelector((state: RootState) => state);

    return (
        <ShortcutMenuWrapper
            title="shortcutMenus.manageAgent.title"
            icon={UserManagementIcon}
            menus={[
                {
                    title: 'Distributors',
                    icon: UserManagementIcon,
                    url: '/distributors',
                    categoryIcon: UserManagementIcon,
                    show: canAccess(state, 'admin.manage.distributors')
                },
                {
                    title: 'Sales Agents',
                    icon: UserManagementIcon,
                    url: '/sales-agents',
                    categoryIcon: UserManagementIcon,
                    show: canAccess(state, 'admin.manage.sales-agents')
                },
                {
                    title: 'Online Marketers',
                    icon: UserManagementIcon,
                    url: '/online-marketers',
                    categoryIcon: UserManagementIcon,
                    show: canAccess(state, 'admin.manage.online-marketers')
                },
            ]}
        />
    );
}
